module.exports = __webpack_public_path__ + "static/media/002.a956238e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gallery/002.jpg
// module id = 546
// module chunks = 0